import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationHandlerComponent } from '../../shared/modal/notification-handler/notification-handler.component';
import { AddSkipperFormComponent } from '../../shared/ui-components/add-skipper-form/add-skipper-form.component';
import { FiltersComponent } from '../../shared/ui-components/filters/filters.component';

@Component({
  selector: 'app-test-ui',
  standalone: true,
  imports: [AddSkipperFormComponent, FiltersComponent],
  templateUrl: './test-ui.component.html',
  styleUrl: './test-ui.component.scss',
})
export class TestUiComponent implements OnInit {
  dialog = inject(MatDialog);

  //https://drheamapi.illisite.info/api/uvcs/253428/modal

  ngOnInit(): void {
    const dialogref = this.dialog.open(NotificationHandlerComponent, {
      data: { projectId: 60, projectName: 'aGOra - Nid de Pie - Vague 1' },
      disableClose: true,
      maxWidth: '90vw',
    });
  }
}
